// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Classes

class Combat {
  constructor () {
    this.turnQueue = ['player','enemy'];
    this.temp = {};
  }

  resetTurnQueue () {this.turnQueue = ['player','enemy'];}
  nextTurn() {
    if (this.turnQueue.length < 1) {
      this.turnQueue = ['player','enemy'];
    }
    let turn = this.turnQueue[0]; //this should be copied by value
    this.turnQueue.splice(0,1);
    return turn;
  }

  calculateDamage(attacker, defender) {
    const damage = this.rollDamageRange(attacker.getAttackRange()) - defender.getTotalDefense();
    return damage < 1 ? 1 : damage;
  }

  rollDamageRange(range) {
    return Math.floor(Math.random() * (range.max - range.min + 1) + range.min)
  }
}

export default Combat;
